import { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from '@tanstack/react-query';
import { LoadingScreen } from '@common/components/LoadingScreen';
import { useToast } from '@ntconsult/aluma-react';
import { consumeRedirectAfterLogin } from '../utils/redirectAfterLogin';
import { ME_QUERY_KEY } from '../hooks/useMe';
import { authService } from '../services/authService';

export function AzureCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { toast } = useToast();
  const { t } = useTranslation('auth');
  const consumedRef = useRef(false);

  useEffect(() => {
    if (consumedRef.current) return;
    consumedRef.current = true;

    const error = searchParams.get('error');
    if (error) {
      toast.danger({ title: t('toasts.azureError') });
      navigate('/login', { replace: true });
      return;
    }

    // Cookies já foram setados pelo backend antes do redirect. Confirmamos
    // sessão buscando /me e seguimos para o destino original.
    (async () => {
      try {
        const user = await authService.getMe();
        queryClient.setQueryData(ME_QUERY_KEY, user);
        toast.success({ title: t('toasts.loginSuccess') });
        navigate(consumeRedirectAfterLogin(), { replace: true });
      } catch {
        toast.danger({ title: t('toasts.azureSessionExpired') });
        navigate('/login', { replace: true });
      }
    })();
  }, [searchParams, navigate, queryClient, toast, t]);

  return <LoadingScreen />;
}
